import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

export default function AboutUs() {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = 'About QRmor — Anti-Counterfeit QR Technology from Scinova Scientifics & CIIRC®';
        const metaDesc = document.querySelector('meta[name="description"]');
        const content = 'QRmor is built by Scinova Scientifics and CIIRC®, combining research and delivery to create non-clonable, anti-counterfeit QR code authentication for regulated industries.';
        if (metaDesc) {
            metaDesc.setAttribute('content', content);
        } else {
            const tag = document.createElement('meta');
            tag.name = 'description';
            tag.content = content;
            document.head.appendChild(tag);
        }
    }, []);

    return (
        <>
            <header>
                <nav className="wrap">
                    <div className="brand">
                        <img src="/assets/QRmor.png" alt="QRmor logo" />
                        <div className="divider" />
                        <img src="/assets/Scinova.png" alt="Scinova Scientifics logo" className="brand-scinova-logo" />
                        <div className="brand-scinova-text">
                            <span className="parent">Scinova Scientifics</span>
                            <span className="brand-tagline"> -Science as a Service</span>
                        </div>
                    </div>
                    <Link to="/" className="btn btn-primary btn-sm">Back to home</Link>
                </nav>
            </header>

            <section>
                <div className="wrap legal-content" style={{ maxWidth: 860, padding: '48px 32px 80px' }}>
                    <span className="eyebrow">Company</span>
                    <h1 style={{ fontSize: 'clamp(28px, 4vw, 40px)', marginTop: 12, marginBottom: 24 }}>
                        About Us
                    </h1>
                    <p style={{ color: 'var(--ink-soft)', fontSize: 16, lineHeight: 1.7 }}>
                        QRmor comes from Scinova Scientifics, a scientific services startup focused on
                        pharma, healthcare, and agri-tech, built under <a href="https://ciirc.res.in" target="_blank" rel="noopener noreferrer">CIIRC®</a> — the Centre for Incubation,
                        Innovation, Research and Consultancy, a Section 8 Scientific and Industrial
                        Research Organization recognized by DSIR, Government of India.
                    </p>
                    <p style={{ color: 'var(--ink-soft)', fontSize: 16, lineHeight: 1.7, marginTop: 20 }}>
                        <a href="https://ciirc.res.in" target="_blank" rel="noopener noreferrer">CIIRC</a> co-developed the anti-counterfeit, non-clonable QRmor code
                        generation technology and the deep-tech-based authentication engine at the core
                        of the product.
                    </p>
                    <ul style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 14, color: 'var(--ink-soft)', fontSize: 15, lineHeight: 1.6, paddingLeft: 20 }}>
                        <li><b>Built from research, not retrofitted</b> — QRmor wasn't added on top of an existing QR product as an afterthought; the non-clonable technology was invented from the ground up at <a href="https://ciirc.res.in" target="_blank" rel="noopener noreferrer">CIIRC</a>.</li>
                        <li><b>One engine, many industries, from day one</b> — the same authentication core was designed to work across pharma, agritech, and beyond, not built narrowly for a single sector and adapted later.</li>
                        <li><b>ISO 27001:2022 certified</b>, reflecting the same institutional rigor QRmor was built under.</li>
                        <li><b>Built for global reach</b> — services designed for the global community, not just a single market.</li>
                    </ul>
                </div>
            </section>
        </>
    );
}